export default function PTTrainingPlansSection() {
  return <>PT - Training Plans</>;
}
